import API from 'app/utils/apiClient';

import { toParams } from 'app/utils/url';

const getFollowingFeeds = (page = 1, perPage = 20) => {
  const params = toParams({ page, perPage });
  return API.get(`/library/following-feeds/?${params}`);
};

const getReadStories = (key, sort) => {
  const params = toParams({ key, sort });
  return API.get(`/library/read-stories/?${params}`);
};

const deleteReadStories = (storyIds) =>
  API.post('/library/read-stories/bulk-delete/', { storyIds });

// liked
const getLikedStories = (page = 1, perPage = 20) => {
  const params = toParams({ page, perPage });
  return API.get(`/library/liked-stories/?${params}`);
};

export default {
  getFollowingFeeds,
  getReadStories,
  deleteReadStories,
  getLikedStories,
};



// WEBPACK FOOTER //
// ./src/app/apis/library.js